import styled from 'styled-components';
import { Box } from '../box';
import Input, { InputProps } from './input';

const InputDiv = styled(({ ...props }: InputProps) => (
  <Input componentClass={Box} role={'textbox'} {...props} />
))<InputProps>`
  cursor: text;
`;

InputDiv.displayName = 'InputDiv';
export default InputDiv;
